/**
 * @generated SignedSource<<41c5c585b1d333916987933df84c8cda>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedItemTile_item$data = {
  readonly isAuctionEnabled: boolean | null;
  readonly serviceId: string | null;
  readonly productPhotos: ReadonlyArray<{
    readonly smallPath: string | null;
    readonly versions: ReadonlyArray<{
      readonly webPath: string | null;
    } | null> | null;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"ItemTileCarousel_item" | "FavoritesItem_item" | "FavoritesItemProvider_item">;
  readonly " $fragmentType": "SharedItemTile_item";
};
export type SharedItemTile_item$key = {
  readonly " $data"?: SharedItemTile_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedItemTile_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "fetchVideo"
    },
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "pageDisplayEnum"
    },
    {
      "defaultValue": 1,
      "kind": "LocalArgument",
      "name": "photosLimit"
    },
    {
      "kind": "RootArgument",
      "name": "showSeller"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedItemTile_item",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "fetchVideo",
          "variableName": "fetchVideo"
        },
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        },
        {
          "kind": "Variable",
          "name": "pageDisplayEnum",
          "variableName": "pageDisplayEnum"
        },
        {
          "kind": "Variable",
          "name": "showSeller",
          "variableName": "showSeller"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ItemTileCarousel_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FavoritesItem_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FavoritesItemProvider_item"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAuctionEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": "productPhotos",
      "args": [
        {
          "kind": "Variable",
          "name": "limit",
          "variableName": "photosLimit"
        }
      ],
      "concreteType": "ItemPhoto",
      "kind": "LinkedField",
      "name": "photos",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "smallPath",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ItemPhotoVersion",
          "kind": "LinkedField",
          "name": "versions",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "webPath",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "2ef6c2b0899b614e3e465c1c9fdc0742";

export default node;
